import ActionTypes from "../constants/action_types";

export default function clearTopicCategories(organisationId) {
  return {
    type: ActionTypes.TOPIC_CATEGORIES_CLEAR.SUCCESS,
    organisation_id: organisationId,
  };
}
